import type { AlphaDesignVersion } from "@nlc/shared-types";

import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";

import { alphaDesignVersionsKey } from "./useAlphaDesignVersionsQuery";

export function useOpenCreatedVersion(
  requestId: number,
  designId: string,
): (version: AlphaDesignVersion) => Promise<void> {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return async (version: AlphaDesignVersion) => {
    await queryClient.invalidateQueries({
      queryKey: alphaDesignVersionsKey(requestId, designId),
    });
    await navigate({
      params: { designId, requestId },
      search: { version: version.id },
      to: "/requests/$requestId/alpha/designs/$designId/edit",
    });
  };
}
